import fetch from './fetch-json.js'
import request from './request.js'
export function insertProject(data) {
    return request({
        url: 'project/insert',
        method: 'post',
        params: data
    });
}
export function getTagsList(data) {
    return request({
        url: 'agencyOptionValue/getProjectTagData',
        method: 'post',
        params: data
    });
}
export function addTagProject(data) {
    return request({
        url: 'agencyProjectFeature/insert',
        method: 'post',
        params: data
    });
}

export function deleteTagProject(data) {
    return request({
        url: 'agencyProjectFeature/delete',
        method: 'post',
        params: data
    });
}

export function deleteTag(data) {
    return request({
        url: 'agencyOptionValue/deleteProjectTag',
        method: 'post',
        params: data
    });
}


export function getSelectTagProject(data) {
    return request({
        url: 'project/getProjectsByFeatureType',
        method: 'post',
        params: data
    });
}
export function getTagProject(data) {
    return request({
        url: 'project/getTagsProjectData',
        method: 'post',
        params: data
    });
}

export function uploadTagOrder(data) {
    return request({
        url: 'agencyOptionValue/updateIntValue',
        method: 'post',
        data: data
    });
}
export function insertTag(data) {
    return request({
        url: 'agencyOptionValue/insertProjectTag',
        method: 'post',
        params: data
    });
}
export function getTags(data) {
    return request({
        url: 'agencyOptionValue/getAgencyOptionValueData',
        method: 'post',
        params: data
    });
}
export function getDepartmentFeatureData(data) {
    return request({
        url: 'departmentFeature/getDataWithProject',
        method: 'post',
        params: data
    });
}
export function insertBatchDepartmentFeature(data) {
    return request({
        url: 'departmentFeature/insertBatch',
        method: 'post',
        params: data
    });
}
export function getAgencyFeatureData(data) {
    return request({
        url: 'agencyFeature/getDataWithProject',
        method: 'post',
        params: data
    });
}
export function insertBatchAgencyFeature(data) {
    return request({
        url: 'agencyFeature/insertBatch',
        method: 'post',
        params: data
    });
}
export function getRequestProject(data) {
    return request({
        url: 'request/getDataForProject',
        method: 'post',
        params: data
    });
}
export function approveProject(data) {
    return request({
        url: 'request/approveProject',
        method: 'post',
        params: data
    });
}

export function approveProjectForAdmin(data) {
    return request({
        url: 'request/approveProjectForAdmin',
        method: 'post',
        params: data
    });
}

export function getOneProject(data) {
    return request({
        url: 'request/getOneDataForProject',
        method: 'post',
        params: data
    });
}
export function addProjectBuilding(data) {
    return request({
        url: 'projectBuilding/insert',
        method: 'post',
        params: data
    });
}
export function changeProjectBuilding(data) {
    return request({
        url: 'projectBuilding/update',
        method: 'post',
        params: data
    });
}
export function deleteProjectBuilding(data) {
    return request({
        url: 'projectBuilding/delete',
        method: 'post',
        params: data
    });
}

export function insertOrUpdateProjectLevel(data) {
    return request({
        url: 'projectlevel/insertOrUpdate',
        method: 'post',
        params: data
    });
}

export function getProjectLevel(data) {
    return request({
        url: 'projectlevel/getProjectLevel',
        method: 'post',
        params: data
    });
}

export function insertSingleListing(data) {
    return request({
        url: 'project/insertSingleListing',
        method: 'post',
        params: data
    });
}

export function querySingleListingByAddress(data) {
    return request({
        url: 'project/queryProjectByAddress',
        method: 'post',
        params: data
    });
}

// 列表
export function getProjectList(data) {
    return request({
        url: 'project/getData',
        method: 'post',
        params: data
    });
}

export function getDataByDepartmentID(data) {
    return request({
        url: 'departmentProject/getDataByDepartmentID',
        method: 'post',
        params: data
    });
}

export function showToDepartment(data) {
    return request({
        url: 'project/showToDepartment',
        method: 'post',
        params: data
    });
}

export function showToDepartmentBatch(data) {
    return request({
        url: 'departmentProject/showToDepartmentBatch',
        method: 'post',
        params: data
    });
}

export function updateProject(data) {
    return request({
        url: 'project/update',
        method: 'post',
        data
    });
}

// project/getProject
export function getProject(data) {
    return request({
        url: 'project/getProject',
        method: 'post',
        params: data
    });
}

// project/getAgentProjectData
export function getAgentProjectData(data, noLoading = false) {
    return request({
        url: 'project/getAgentProjectData',
        method: 'post',
        params: data,
        noLoading
    });
}

// project/getProjectDisplayData
export function getProjectDisplayData(data, noLoading = false) {
    return request({
        url: 'project/getProjectDisplayData',
        method: 'post',
        params: data,
        noLoading
    });
}

// project/getDataByPrimaryKey
export function getProjectData(data) {
    return request({
        url: 'project/getDataByPrimaryKey',
        method: 'post',
        params: data
    });
}

//视图
// project/getProjectPictureData
export function getProjectPictureData(data) {
    return request({
        url: 'project/getProjectPictureData',
        method: 'post',
        params: data
    });
}

export function getAllProjectData(data) {
    return request({
        url: 'project/getAllProjectData',
        method: 'post',
        params: data
    });
}

export function getPlatformProject(data) {
    return request({
        url: 'project/getPlatformProject',
        method: 'post',
        params: data
    });
}

export function getAgencyProjectData(data) {
    return request({
        url: 'agencyproject/getData',
        method: 'post',
        params: data
    });
}

export function getAgencyProject(data) {
    return request({
        url: 'agencyproject/getAgencyProject',
        method: 'post',
        params: data
    });
}

export function getTreeData(data) {
    return request({
        url: 'agencyproject/getTreeData',
        method: 'post',
        params: data
    });
}
// ------------------------project-contactInsert

// 新增联系人接口
export function insertAgencyProjectContact(data) {
    return request({
        url: 'agencyProjectContact/insert',
        method: 'post',
        params: data
    });
}
// 获取所以联系人接口
export function agencyProjectContactList(data) {
    return request({
        url: 'agencyProjectContact/getData',
        method: 'post',
        params: data
    });
}

// 删除联系人接口
export function deltadeAgencyProjectContact(data) {
    return request({
        url: 'agencyProjectContact/delete',
        method: 'post',
        params: data
    });
}

// ---------------all project-attachment
export function deleteAllAttachments(data) {
    return request({
        url: 'attachment/deleteChecklistAtt',
        method: 'post',
        params: data
    });
}

export function deleteAttachment(data) {
    return request({
        url: 'attachment/delete',
        method: 'post',
        params: data
    });
}

export function getAttachmentList(data) {
    return request({
        url: 'attachment/getData',
        method: 'post',
        params: data
    });
}

export function updateShowInternal(data) {
    return request({
        url: 'attachment/updateShowInternal',
        method: 'post',
        params: data
    });
}

export function insertAttachment(data) {
    return request({
        url: 'attachment/insert',
        method: 'post',
        params: data
    });
}
// attachment/insertList
export function insertAttachmentList(data) {
    return fetch({
        url: 'attachment/insertList',
        method: 'post',
        data: data
    });
}

export function updateAttachment(data) {
    return request({
        url: 'attachment/update',
        method: 'post',
        params: data
    });
}

// picture/insertList
export function insertPictureList(data) {
    return request({
        url: 'picture/insertList',
        method: 'post',
        params: data
    });
}
// picture----------
export function deletePicture(data) {
    return request({
        url: 'picture/delete',
        method: 'post',
        params: data
    });
}
export function getPictureList(data) {
    return request({
        url: 'picture/getData',
        method: 'post',
        params: data
    });
}
export function insertPicture(data) {
    return request({
        url: 'picture/insert',
        method: 'post',
        params: data
    });
}
export function uptadePicture(data) {
    return request({
        url: 'picture/update',
        method: 'post',
        params: data
    });
};
export function uptadePictureToLogo(data) {
    return request({
        url: 'picture/updateIsLogo',
        method: 'post',
        params: data
    });
}
// ----Property
export function batchTeamSingleListing(data) {
    return request({
        url: 'property/batchTeamSingleListing',
        method: 'post',
        params: data
    });
}

export function deleteProperty(data) {
    return request({
        url: 'property/delete',
        method: 'post',
        params: data
    });
}
export function getPropertyList(data) {
    return request({
        url: 'property/getData',
        method: 'post',
        params: data
    });
}

export function getPropertyListForPriceList(data) {
    return request({
        url: 'property/getMultiStatusData',
        method: 'post',
        params: data
    });
}

export function getPropertyDataForMarketplace(data) {
    return request({
        url: '/property/getDataForMarketplace',
        method: 'post',
        params: data
    });
}

export function getProjectBuilding(data) {
    return request({
        url: 'projectBuilding/getData',
        method: 'post',
        params: data
    });
}
export function getRelatedSales(data) {
    return request({
        url: 'sale/getRelatedSales',
        method: 'post',
        params: data
    });
}
export function getProperty(data) {
    return request({
        url: 'property/getProperty',
        method: 'post',
        params: data
    });
}
export function getPropertyAddress(data) {
    return request({
        url: 'project/selectAddressByPrimaryKey',
        method: 'post',
        params: data
    });
}
export function insertProperty(data) {
    return request({
        url: 'property/insert',
        method: 'post',
        params: data
    });
}
export function uptadeProperty(data) {
    return request({
        url: 'property/update',
        method: 'post',
        params: data
    });
}
export function addPropertyAttachment(data) {
    return request({
        url: 'property/addAttachment',
        method: 'post',
        params: data
    });
}
export function addPropertyPicture(data) {
    return request({
        url: 'property/addPicture',
        method: 'post',
        params: data
    });
}
export function removePropertyAttachment(data) {
    return request({
        url: 'property/removeAttachment',
        method: 'post',
        params: data
    });
}
export function removePropertyPicture(data) {
    return request({
        url: 'property/removePicture',
        method: 'post',
        params: data
    });
}
export function getPropertyByLotNumer(data) {
    return request({
        url: 'property/getPropertyByLotNumer',
        method: 'post',
        params: data
    });
}
// 解析数据 存库  property/excelImport
export function importPropertyData(data) {
    return request({
        url: 'property/excelImport',
        method: 'post',
        params: data
    });
}
// 批量上传模板下载  attachment/getExcelISForAs
export function getExcelISForAs(data) {
    return request({
        url: 'attachment/getExcelISForAs',
        method: 'post',
        params: data
    });
}

export function insertUpdateDisplayInfo(data) {
    return request({
        url: 'projectDisplayInfo/insertAndUpdate',
        method: 'post',
        params: data
    });
}
// projectDisplayInfo/getData，参数：projectid  展厅回显接口
export function getDisplayInfo(data) {
    return request({
        url: 'projectDisplayInfo/getData',
        method: 'post',
        params: data
    });
}
export function deleteDisplayInfo(data) {
    return request({
        url: 'projectDisplayInfo/delete',
        method: 'post',
        params: data
    });
}

// agency/getShareData
// 所有数据
export function getSharetoList(data) {
    return request({
        url: 'agency/getShareData',
        method: 'post',
        params: data
    });
}
// agencyproject/insert
//增加
export function insertShareto(data) {
    return request({
        url: 'agencyproject/insert',
        method: 'post',
        params: data
    });
}
export function insertSharetoBatch(data) {
    return request({
        url: 'agencyproject/insertBatch',
        method: 'post',
        params: data
    });
}
export function insertSingle(data) {
    return request({
        url: 'agencyproject/insertSingle',
        method: 'post',
        params: data
    });
}

export function getUpperShareAgency(data) {
    return request({
        url: 'agencyproject/getUpperShareAgency',
        method: 'post',
        params: data
    });
}
// agencyproject/delete 删除
export function deleteShareto(data) {
    return request({
        url: 'agencyproject/delete',
        method: 'post',
        params: data
    });
}
// agencyproject/delete 删除
export function deleteSharetoBatch(data) {
    return request({
        url: 'agencyproject/deleteBatch',
        method: 'post',
        params: data
    });
}
export function checkExistAssociated(data) {
    return request({
        url: 'agencyproject/checkExistAssociated',
        method: 'post',
        params: data
    });
}

export function checkExistPendingApprovalForDelete(data) {
    return request({
        url: 'agencyproject/checkExistPendingApprovalForDelete',
        method: 'post',
        params: data
    });
}

export function checkExistPendingApprovalForChange(data) {
    return request({
        url: 'agencyproject/checkExistPendingApprovalForChange',
        method: 'post',
        params: data
    });
}

export function pushNewProject(data) {
    return request({
        url: 'project/pushMessage',
        method: 'post',
        params: data
    });
}

// 查询共享项目详细数据接口地址：/project/getSharedProjects
export function getSharedProjects(data) {
    return request({
        url: 'project/getSharedProjects',
        method: 'post',
        params: data
    });
}


export function attachmentGetData(data) {
    return request({
        url: 'attachment/getData',
        method: 'post',
        params: data
    });
}


export function agencyAttachmentinsert(data) {
    return request({
        url: 'agency/attachmentinsert',
        method: 'post',
        params: data
    });
}


export function attachmentDelete(data) {
    return request({
        url: 'attachment/delete',
        method: 'post',
        params: data
    });
}


export function agencyApproverInsert(data) {
    return request({
        url: 'agencyApprover/insert',
        method: 'post',
        params: data
    });
}

export function agencyApproverGetData(data) {
    return request({
        url: 'agencyApprover/getData',
        method: 'post',
        params: data
    });
}

// commission/insertCommissionBy99
export function upsertCommission(data) {
    return request({
        url: 'commission/upsertCommission',
        method: 'post',
        params: data
    });
}

// agencyProjectApprove/update

export function agencyApproveUpdate(data) {
    return request({
        url: 'agencyProjectApprove/update',
        method: 'post',
        params: data
    });
}
export function agencyGetToShareAgency(data) {
    return request({
        url: 'agency/getToShareAgency',
        method: 'post',
        params: data
    });
}

// /logo/getData
export function getProjectLogo(data) {
    return request({
        url: 'logo/getData',
        method: 'post',
        params: data
    });
}
// /logo/insert 
export function insertProjectLogo(data) {
    return request({
        url: 'logo/insert',
        method: 'post',
        params: data
    });
}
// projectArticle/getData
export function getProjectArticle(data) {
    return request({
        url: 'projectArticle/getData',
        method: 'post',
        params: data
    });
}
// projectArticle/insert 
export function insertProjectArticle(data) {
    return request({
        url: 'projectArticle/insert',
        method: 'post',
        params: data
    });
}
// projectArticle/update
export function updateProjectArticle(data) {
    return request({
        url: 'projectArticle/update',
        method: 'post',
        params: data
    });
}
// /projectArticle/delete  输入参数：ids：articleid
export function deleteProjectArticle(data) {
    return request({
        url: 'projectArticle/delete',
        method: 'post',
        params: data
    });
}
// projectOutlink/getData
export function getProjectOutlink(data) {
    return request({
        url: 'projectOutlink/getData',
        method: 'post',
        params: data
    });
}
// projectOutlink/insert 
export function insertProjectOutlink(data) {
    return request({
        url: 'projectOutlink/insert',
        method: 'post',
        params: data
    });
}
// projectOutlink/update
export function updateProjectOutlink(data) {
    return request({
        url: 'projectOutlink/update',
        method: 'post',
        params: data
    });
}
// /projectOutlink/delete  输入参数：ids：linkid
export function deleteProjectOutlink(data) {
    return request({
        url: 'projectOutlink/delete',
        method: 'post',
        params: data
    });
}
// project/getCategory 查询项目类别
export function getProjectCategory(data) {
    return request({
        url: 'project/getCategory',
        method: 'post',
        params: data
    });
}
// property/updateHoldingflag   参数：propertyid，holdingflag
export function updateHoldingflag(data) {
    return request({
        url: 'property/updateHoldingflag',
        method: 'post',
        params: data
    });
}
// property/updateMarkAsSold   参数：propertyid，markassold
export function updateMarkAsSold(data) {
    return request({
        url: 'property/updateMarkAsSold',
        method: 'post',
        params: data
    });
}
export function handlePropertyBatch(data) {
    return request({
        url: 'property/handlePropertyBatch',
        method: 'post',
        params: data
    });
}
// project/getHomeProject  查询project Edit 页面数据
export function getHomeProject(data) {
    return request({
        url: 'project/getProjectDetails',
        method: 'post',
        params: data
    });
}
// separate from "project/getHomeProject" to make it more clear and faster to use
export function getNewHomeProject(data) {
    return request({
        url: 'project/getNewHomeProject',
        method: 'post',
        params: data
    });
}
export function getHomeAttachment(data) {
    return request({
        url: 'project/getHomeAttachment',
        method: 'post',
        params: data
    });
}
export function getHomePicture(data) {
    return request({
        url: 'project/getHomePicture',
        method: 'post',
        params: data
    });
}
export function getHomeBuilding(data) {
    return request({
        url: 'project/getHomeBuilding',
        method: 'post',
        params: data
    });
}
export function getHomeAgencyProjectContact(data) {
    return request({
        url: 'project/getHomeAgencyProjectContact',
        method: 'post',
        params: data
    });
}
export function getHomeSpecial(data) {
    return request({
        url: 'project/getHomeSpecial',
        method: 'post',
        params: data
    });
}
// project/getHomeProjectForMarketplace
export function getHomeProjectForMarketplace(data) {
    return request({
        url: 'project/getHomeProjectForMarketplace',
        method: 'post',
        params: data
    });
}

// agencyproject/update  修改agencyproject  热卖字段
export function updateAgencyproject(data) {
    return request({
        url: 'agencyproject/update',
        method: 'post',
        params: data
    });
}
export function changeVisibility(data) {
    return request({
        url: 'project/updateVisibility',
        method: 'post',
        params: data
    });
}
export function updateProjectAutoEmail(data) {
    return request({
        url: 'project/updateVisibility',
        method: 'post',
        params: data
    });
}
export function updateSingle(data) {
    return request({
        url: '/agencyproject/updateSingle',
        method: 'post',
        params: data
    });
}

//是否内部模板按钮数据回显接口
export function getIsShowInternalTemplates(data){
    return request({
        url: '/project/getIsShowInternalTemplates',
        method: 'post',
        params: data
    });
}

//   edm body 图片上传接口
export function insertEdm(data) {
    return request({
        url: 'edm/insert',
        method: 'post',
        params: data
    });
}
//   edm body 图片删除接口
export function deleteEdm(data) {
    return request({
        url: 'edm/delete',
        method: 'post',
        params: data
    });
}
//   edm body 图片查询接口
export function getEdm(data) {
    return request({
        url: 'edm/getData',
        method: 'post',
        params: data
    });
}
// project/getSharedToAgency  分享出去的项目list
export function getSharedToAgency(data) {
  return request({
      url: 'project/getSharedToAgency',
      method: 'post',
      params: data
  });
}
// 价目表pdf 下载
// property/PdfProperty
export function PdfProperty(data) {
  return request({
      url: 'property/PdfProperty',
      method: 'post',
      params: data
  });
}

// agency/getShareData
// 所有数据
export function getSharedFromAgency(data) {
    return request({
        url: 'project/getSharedFromAgency',
        method: 'post',
        params: data
    });
}

export function agencyProjectGetAllData(data) {
    return request({
        url: 'agencyproject/getAllData',
        method: 'post',
        params: data
    });
}

export function getProjectOptionData(data) {
    return request({
        url: 'project/getOptionData',
        method: 'post',
        params: data
    });
}

export function getAllProjectOptionData(data) {
    return request({
        url: 'project/getAllOptionData',
        method: 'post',
        params: data
    });
}

export function getSharedByOther(data) {
    return request({
        url: 'project/getSharedByOther',
        method: 'post',
        params: data
    })
}

export function getSharedFromUs(data) {
    return request({
        url: 'project/getSharedFromUs',
        method: 'post',
        params: data
    })
}

export function getDataWithShare(data) {
    return request({
        url: 'project/getDataWithShare',
        method: 'post',
        params: data
    })
}

export function updateAgreement(data) {
    return request({
        url: 'agencyprojectagreement/update',
        method: 'post',
        params: data
    })
}

export function getAgreementData(data) {
    return request({
        url: 'agencyprojectagreement/getData',
        method: 'post',
        params: data
    })
}

export function getAgreementDataGeneral(data) {
    return request({
        url: 'agencyagreement/getData',
        method: 'post',
        params: data
    })
}

export function deleteAgreementFile(data) {
    return request({
        url: 'agencyprojectagreement/delete',
        method: 'post',
        params: data
    })
}

export function deleteAgreementFileGeneral(data) {
    return request({
        url: 'agencyagreement/delete',
        method: 'post',
        params: data
    })
}

export function updateExpiryDateTime(data) {
    return request({
        url: 'agencyprojectagreement/updateExpiryDateTime',
        method: 'post',
        params: data
    })
}

export function updateExpiryDateTimeGeneral(data) {
    return request({
        url: 'agencyagreement/updateExpiryDateTime',
        method: 'post',
        params: data
    })
}

export function syncChannelSale(data) {
    return request({
        url: 'agencyproject/syncChannelSale',
        method: 'post',
        params: data
    })
}
export function getPropertyByDeptID(data) {
    return request({
        url: 'property/getDataByDeptID',
        method: 'post',
        params: data
    })
}
export function getDataByChannelID(data) {
    return request({
        url: 'property/getDataByChannelID',
        method: 'post',
        params: data
    })
}
export function getVisibleData(data) {
    return request({
        url: 'property/getVisibleData',
        method: 'post',
        params: data
    })
}
export function insertDepartmentProperty(data) {
    return request({
        url: 'departmentproperty/insert',
        method: 'post',
        params: data
    })
}
export function insertChannelProperty(data) {
    return request({
        url: 'agencyproperty/insert',
        method: 'post',
        params: data
    })
}
export function insertDepartmentPropertyBatch(data) {
    return request({
        url: 'departmentproperty/insertInternalBatch',
        method: 'post',
        params: data
    })
}
export function insertChannelPropertyBatch(data) {
    return request({
        url: 'agencyproperty/insertExternalBatch',
        method: 'post',
        params: data
    })
}

export function getSelectionBoxProject(){
    return request({
        url: 'project/getSelectionBoxProjectInAgency',
        method: 'post',
    });
  }

  
export function getAgencyProjects(data){
    return request({
        url: 'project/getProjects4BatchShare',
        method: 'post',
        params:data
    });
  }

export function saveBatchShareData(data){
    return request({
        url: 'agencyproject/insertBatchShare',
        method: 'post',
        params:data
    });
}

export function getAgencyPropertyLogData(data){
    return request({
        url: 'agencyproperty/getLogData',
        method: 'post',
        params:data
    });
}

export function insertAgreement(data) {
    return request({
        url: 'agencyprojectagreement/insert',
        method: 'post',
        params: data
    })
}

// no project
export function insertAgreementGeneral(data) {
    return request({
        url: 'agencyagreement/insert',
        method: 'post',
        params: data
    })
}

export function getSelectionBoxProjectToAgency(data){
    return request({
        url: 'project/getSelectionBoxProjectToAgency',
        method: 'post',
        params: data
    });
}

// /project/getCurrency
export function getCurrency(data) {
    return request({
        url: 'project/getCurrency',
        method: 'post',
        params: data    
    });
}

//agencyProjectVariation/getData
export function getProjectVariationData (data){
    return request({
      url: 'agencyProjectVariation/getData',
      method: 'post',
      params: data
    });
  }

//agencyProjectVariation/getDataWithSale
export function getProjectVariationDataWithSale (data){
    return request({
      url: 'agencyProjectVariation/getDataWithSale',
      method: 'post',
      params: data
    });
  }
  
  //agencyProjectVariation/update
  export function updateProjectVariation (data){
    return request({
      url: 'agencyProjectVariation/update',
      method: 'post',
      params: data
    });
  }
  
  //agencyProjectVariation/insert
  export function insertProjectVariation (data){
    return request({
      url: 'agencyProjectVariation/insert',
      method: 'post',
      params: data
    });
  }
  
  //agencyProjectVariation/delete
  export function deleteProjectVariation (data){
    return request({
      url: 'agencyProjectVariation/delete',
      method: 'post',
      params: data
    });
  }

//检查该agent有无访问权限
export function checkPermission(data) {
    return request({
        url: 'project/checkPermission',
        method: 'post',
        params: data
    });
}

// stats
export function getNewProjectActivities(data) {
    return request({
        url: 'project/getNewProjectActivities',
        method: 'post',
        params: data
    });
}

// project/getDataForSelect
export function getDataForSelect(data) {
    return request({
        url: 'project/getDataForSelect',
        method: 'post',
        params: data
    });
}

// project/getProjectTotal
export function getProjectTotal(data) {
    return request({
        url: 'project/getProjectTotal',
        method: 'post',
        params: data
    });
}

//agency delete all project sharing 
export function agencyDeleteAllSharing(data) {
    return request({
        url: 'agencyproject/deleteAll',
        method: 'post',
        params: data
    });
}

//department delete all project sharing
export function departmentDeleteAllSharing(data) {
    return request({
        url: 'departmentProject/hideToAllProject',
        method: 'post',
        params: data
    });
}

// 
export function setAgencyRestAllCommissions(data) {
    return request({
        url: 'agencyproject/insertAllProject',
        method: 'post',
        params: data
    });
}

export function getAutoAssign(data) {
    return request({
        url: 'agencyProjectMarket/getAutoAssign',
        method: 'post',
        params: data
    });
}

export function updateAutoAssign(data) {
    return request({
        url: 'agencyProjectMarket/updateAutoAssign',
        method: 'post',
        params: data
    });
}

export function updateAutoAssignBulk(data) {
    return request({
        url: 'agencyProjectMarket/updateAutoAssignBulk',
        method: 'post',
        params: data
    });
}

export function getWebhook(data) {
    return request({
        url: 'agencywebhook/getWebhook',
        method: 'post',
        params: data
    });
}

//customised Contact
export function getCustomisedContacts(data) {
    return request({
        url: 'customisedContact/getData',
        method: 'post',
        params: data
    });
}

export function insertCustomisedContact(data) {
    return request({
        url: 'customisedContact/insert',
        method: 'post',
        params: data
    });
}

export function addProjectContact(data) {
    return request({
        url: 'agencyProjectCustomisedContact/insert',
        method: 'post',
        params: data
    });
}


// Customised Contact Tab页
export function getProjectCustomisedContacts(data) {
    return request({
        url: 'agencyProjectCustomisedContact/getData',
        method: 'post',
        params: data
    });
}

export function deleteProjectCustomisedContact(data) {
    return request({
        url: 'agencyProjectCustomisedContact/delete',
        method: 'post',
        params: data
    });
}

export function getHouseDesigns(data) {
    return request({
        url: 'houseDesignOption/getData',
        method: 'post',
        params: data
    });
}

export function insertHouseDesign(data) {
    return request({
        url: 'houseDesignOption/insert',
        method: 'post',
        params: data
    });
}

export function updateHouseDesign(data) {
    return request({
        url: 'houseDesignOption/update',
        method: 'post',
        params: data
    });
}

export function deleteHouseDesign(data) {
    return request({
        url: 'houseDesignOption/delete',
        method: 'post',
        params: data
    });
}

export function getPropertyVariation(data) {
    return request({
        url: 'propertyVariation/getData',
        method: 'post',
        params: data
    });
}

export function insertPropertyVariation(data) {
    return request({
        url: 'propertyVariation/insert',
        method: 'post',
        params: data
    });
}

export function getFacadeImage(data) {
    return request({
        url: 'propertyFacadeImage/getData',
        method: 'post',
        params: data
    });
}

export function insertFacadeImage(data) {
    return request({
        url: 'propertyFacadeImage/insert',
        method: 'post',
        params: data
    });
}

export function updateFacadeImage(data) {
    return request({
        url: 'propertyFacadeImage/update',
        method: 'post',
        params: data
    });
}

export function deleteFacadeImage(data) {
    return request({
        url: 'propertyFacadeImage/delete',
        method: 'post',
        params: data
    });
}

export function copyVariation(data) {
    return request({
        url: 'agencyproject/copyVariation',
        method: 'post',
        params: data
    });
}

//lead提交信息的接口
export function insertLeadDataQRForm(data) {
    return request({
        url: "client/qrInsert",
        method: "post",
        params: data,
    });
}

//admin提交编辑内容
export function upsertQRFormData(data) {
    return request({
        url: "captureform/upsert",
        method: "post",
        params: data,
    });
}

export function getQRFormData(data) {
    return request({
        url: "captureform/getData",
        method: "post",
        params: data,
    });
}

//eflyer edm 
export function upsertFlyer(data, noLoading = false) {
    return request({
        url: "edmTemplate/insertOrUpdate",
        method: "post",
        params: data,
        noLoading: noLoading
    });
}

export function getSelectedFlyer(data) {
    return request({
        url: "edmTemplate/getEdmTemplate",
        method: "post",
        params: data,
    });
}

export function deleteFlyer(data) {
    return request({
        url: "edm/delete",
        method: "post",
        params: data,
    });
}

export function getFlyer(data) {
    return request({
        url: "edm/getData",
        method: "post",
        params: data,
    });
}

export function getAllDefaultFlyer(data) {
    return request({
        url: "property/getPropertys",
        method: "post",
        params: data,
    });
}

export function exportDataOfProject(data) {
    return request({
      url: 'dataExport/exportDataOfProjects',
      method: 'post',
      params: data  
    });
  }

  export function exportDataOfProperty(data) {
    return request({
      url: 'dataExport/exportDataOfUnits',
      method: 'post',
      params: data  
    });
  }

  export function exportDataOfAccess(data) {
    return request({
      url: 'dataExport/exportDataOfAccess',
      method: 'post',
      params: data  
    });
  }

  export function insertInternalColour(data) {
    return request({
      url: 'propertyInternalColour/insert',
      method: 'post',
      params: data  
    });
  }  
  export function updateInternalColour(data) {
    return request({
      url: 'propertyInternalColour/update',
      method: 'post',
      params: data  
    });
  }

  export function getInternalColour(data) {
    return request({
      url: 'propertyInternalColour/getData',
      method: 'post',
      params: data  
    });
  }

  export function deleteInternalColour(data) {
    return request({
      url: 'propertyInternalColour/delete',
      method: 'post',
      params: data  
    });
  }

  export function updateProjectFields(data) {
    return request({
      url: "project/updateProject",
      method: "post",
      params: data,
    });
  }

  export function getProjectSummary(data) {
    return request({
      url: "project/getProjectSummary",
      method: "post",
      params: data,
    });
  }

  export function getProjectLog(data) {
    return request({
        url: "projectLog/getData",
        method: "post",
        params: data,
    });
  }

  export function syncPropertyPrice(data) {
    return request({
        url: "agencyproject/syncPropertyPrice",
        method: "post",
        params: data,
    });
  }

  export function exportEdmPdf(data) {
    return request({
        url: "projectPdf/exportEdmPdf",
        method: "post",
        params: data,
    });
  }
 

  export function getMultiVariationList(data) {
    return request({
        url: "agencyProjectMultiVariation/getData",
        method: "post",
        params: data,
    });
  }

  export function updateMultiVariation(data) {
    return request({
        url: "agencyProjectMultiVariation/update",
        method: "post",
        params: data,
    });
  }

  export function getMultiVariationCount(data) {
    return request({
        url: "houseDesignOption/getCount",
        method: "post",
        params: data,
    });
  }

  export function upsertPresentationData(data) {
    return request({
        url: "presentation/insertOrUpdatePresentation",
        method: "post",
        params: data,
    });
  }

  export function getPresentationData(data) {
    return request({
        url: "presentation/getPresentation",
        method: "post",
        params: data,
    });
  }

  export function insertPresentationGallery(data) {
    return request({
        url: "presentation/insertPresentationGallery",
        method: "post",
        params: data,
    });
  }

  export function getPresentationGallery(data) {
    return request({
        url: "presentation/getPresentationGalleryData",
        method: "post",
        params: data,
    });
  }

  export function updatePresentationGallery(data) {
    return request({
        url: "presentation/updatePresentationGallery",
        method: "post",
        params: data,
    });
  }

  export function deletePresentationGallery(data) {
    return request({
        url: "presentation/deletePresentationGallery",
        method: "post",
        params: data,
    });
  }

  export function insertPresentationFloor(data) {
    return request({
        url: "presentation/insertPresentationFloor",
        method: "post",
        params: data,
    });
  }

  export function deletePresentationFloor(data) {
    return request({
        url: "presentation/deletePresentationFloor",
        method: "post",
        params: data,
    });
  }

  export function updatePresentationFloor(data) {
    return request({
        url: "presentation/updatePresentationFloor",
        method: "post",
        params: data,
    });
  }

  export function getPresentationFloor(data) {
    return request({
        url: "presentation/getPresentationFloorData",
        method: "post",
        params: data,
    });
  }
  
  
export function showToAllTeam(data) {
    return request({
        url: "property/showToAllTeam",
        method: "post",
        params: data,
    });
  }


export function updateProjectUserSetting(data) {
  return request({
    url: "projectUserSetting/update",
    method: "post",
    params: data,
  });
}

export function getProjectUserSetting(data) {
  return request({
    url: "projectUserSetting/getData",
    method: "post",
    params: data,
  });
}

export function getDisclaimer(data) {
  return request({
    url: "project/getDisclaimer",
    method: "post",
    params: data,
  });
}

export function updatePromotionalBubbleText(data) {
  return request({
    url: "agencyproject/updatePromotionalBubbleText",
    method: "post",
    params: data,
  });
}

export function getBubbleTextSetting(data) {
  return request({
    url: "agencyproject/getBubbleTextSetting",
    method: "post",
    params: data,
  });
}



export function getPropertyLog(data) {
    return request({
      url: "property/getPropertyLog",
      method: "post",
      params: data,
    });
  }

export function getProjectShareData(data) {
  return request({
    url: "project/getProjectShareData",
    method: "get",
    params: data,
  });
}

export function getProjectViewData(data) {
  return request({
    url: "project/getProjectViewData",
    method: "get",
    params: data,
  });
}

export function getFeatureProjectList(data) {
  return request({
    url: "project/getFeatureProjectList",
    method: "get",
    params: data,
  });
}

// ---------- Start Bulk Upload Property API -----------
export function getAttachmentAndPictureData(data) {
  return request({
    url: "attachment/getAttachmentAndPictureData",
    method: "post",
    params: data,
  });
}

export function deleteAttachmentOrPicture(data) {
  return request({
    url: "project/deleteAttachmentOrPicture",
    method: "post",
    params: data,
  });
}

export function updateAttachmentAndPictureList(data) {
  return request({
    url: "project/updateAttachmentAndPictureList",
    method: "post",
    params: data,
  });
}

// ---------- End Bulk Upload Property API -----------



// WEBPACK FOOTER //
// ./src/api/projectApi.js